import React from "react";
import { Box, Typography } from "@mui/material";
import DragDropWorkspace from "../components/DragDropWorkspace";

const ManualMatchingPage: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Matching Manual
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Arraste e solte para criar matches manualmente entre faturas e transações.
        </Typography>
      </Box>
      <DragDropWorkspace />
    </Box>
  );
};

export default ManualMatchingPage;
